module.exports = require('./feedforwardNeuralNetwork');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fnn/src/index.js
 ** module id = 143
 ** module chunks = 0
 **/